module.exports = __webpack_public_path__ + "CoryFreemanDesign.jpg?2d4ea1dcf90f54eacb3a44996eee830c";


//////////////////
// WEBPACK FOOTER
// ./public/creator-avatar/CoryFreemanDesign.jpg
// module id = 452
// module chunks = 0